import { createContext, type Dispatch, type PropsWithChildren, useContext, useEffect, useReducer } from 'react';
import storage from '../helpers/storage';
import { getDefaultLocalPreference, initialLocalPreferenceState, localPreferenceActions, type LocalPreferenceState } from './context';
import { localPreferenceReducer } from './reducers/localPreferenceReducer';
type LocalPreferenceContextType = {
  state: LocalPreferenceState;
  dispatch: Dispatch<any>;
};
const LocalPreferenceContext = createContext<LocalPreferenceContextType>({
  state: initialLocalPreferenceState,
  dispatch: () => {}
});
export const useLocalPreferenceState = () => {
  return useContext(LocalPreferenceContext);
};
export const LocalPreferenceContextProvider = ({
  children
}: PropsWithChildren) => {
  const [state, dispatch] = useReducer(localPreferenceReducer, getDefaultLocalPreference());

  // Load preferences from storage on mount
  // Uses storage abstraction: localStorage (web) or AsyncStorage (mobile)
  useEffect(() => {
    const loadFromStorage = async () => {
      try {
        const data = await storage.getItem('localPreference');
        if (data) {
          const parsed = JSON.parse(data) as LocalPreferenceState;
          // Validate that required fields are present
          if (parsed.postFilterType !== null && parsed.postFilterType !== undefined) {
            dispatch({
              type: localPreferenceActions.initializePreference,
              payload: parsed
            });
          }
        }
      } catch (error) {
        console.error('Error loading localPreference from storage:', error);
      }
    };
    void loadFromStorage();
  }, []);
  return <LocalPreferenceContext.Provider value={{
    state,
    dispatch
  }}>
      {children}
    </LocalPreferenceContext.Provider>;
};